import { apiGet } from '../../api'

export const get_greenlight = () => {
  return apiGet({
    endpoint: 'greenlight/get_greenlight'
  })
}
